module.exports = __webpack_public_path__ + "static/img/li1_1.5ba60a44.png";